import useFetch from 'utils/hooks/useFetch'
import { ApiCreateReseller, ApiDeleteReseller, ApiGetResellerList } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function ResellerService() {
    const { showFail } = useModal()

    const { fetch: apiGetResellerList } = useFetch(ApiGetResellerList)
    const { fetch: apiCreateReseller } = useFetch(ApiCreateReseller)
    const { fetch: apiDeleteReseller } = useFetch(ApiDeleteReseller)
 
    const fetchResellerList = async(resellerName, pageSize, pageIndex) => {
        const res =  await apiGetResellerList({
            data: {
                resellerName,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateReseller = async (customerId) => {
        const res = await apiCreateReseller({
            data: { 
                customerId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteReseller = async (resellerId) => {
        const res = await apiDeleteReseller({
            data:{
                resellerId
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchResellerList,
        fetchCreateReseller,
        fetchDeleteReseller,
    }
}